import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as _ from 'lodash';

@Component({
	selector: 'bt-ids-filter-list',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatButtonModule, MatInputModule, CommonModule, MatNativeDateModule, MatDatepickerModule],
	templateUrl: './ids-filter-list.component.html',
	styleUrl: './ids-filter-list.component.scss'
})
export class IdsFilterListComponent implements OnInit {
	readonly #dialogRef = inject(MatDialogRef<IdsFilterListComponent>);
	data = inject(MAT_DIALOG_DATA);

	ids: Array<number | string | null> = [];
	inputType: 'number' | 'text' = 'number';

	ngOnInit(): void {
		this.data = _.cloneDeep(this.data);
		this.inputType = this.data.inputType === 'text' ? 'text' : 'number';

		if (!this.data.selected) {
			this.ids = [null];
		} else {
			this.ids = this.data.selected;
		}
	}

	removeId(index: number): void {
		this.ids.splice(index, 1);
	}

	addId(): void {
		this.ids.push(null);
	}

	apply() {
		const values = this.ids.filter((id) => id !== null && id !== undefined && `${id}`.trim() !== '');
		this.#dialogRef.close(
			this.inputType === 'text' ? values.map((id) => `${id}`.trim()) : values
		);
	}

	onClose(): void {
		this.#dialogRef.close();
	}
}
